<div
  class="container"
  *ngIf="{
    isPasswordChangeActive: isPasswordChangeActive$ | async,
    isEmailChangeActive: isEmailChangeActive$ | async,
    userMail: userMail$ | async
  } as data"
>
  <div class="profile-section" *ngIf="!data.isEmailChangeActive">
    <div class="profile-info">
      <h3>{{ 'label.UserMail' | translate }}</h3>
      <p>
        {{ data.userMail }}
      </p>
    </div>

    <div class="profile-action">
      <button
        [ngClass]="{'change-email-active' : data.isPasswordChangeActive || data.isemailChangeActive,}"
        class="change-email"
        (click)="onChangeEmail()"
      >
        {{ 'label.ChangeEmail' | translate }}
      </button>
    </div>
  </div>

  <div
    [formGroup]="editForm"
    class="mail-container"
    #ngForm="ngForm"
    *ngIf="data.isEmailChangeActive"
  >
    <h3 class="edit-email-label">{{ 'label.EditUserEmail' | translate }}</h3>
    <div class="form-container-wrapper">
      <div class="left-side"></div>
      <div class="form-container">
        <div class="form-group">
          <label>{{ 'label.CurrentEmail' | translate }}</label>
          <input
            type="email"
            [value]="data.userMail"
            disabled
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>{{ 'label.NewEmail' | translate }}</label>
          <input type="email" formControlName="newEmail" class="form-control" autocomplete="off" />

          <mat-error
            class="validation-message"
            *ngIf="editForm.get('newEmail')?.errors?.['required'] && (editForm.controls['newEmail'].touched || ngForm.submitted)"
          >
            {{ 'message.MandatoryField' | translate }}
          </mat-error>
          <mat-error
            class="validation-message"
            *ngIf="editForm.get('newEmail')?.errors?.['pattern'] && (editForm.controls['newEmail'].touched || ngForm.submitted)"
          >
            {{ 'message.IncorrectFormat' | translate }}
          </mat-error>
          <mat-error
            class="validation-message"
            *ngIf="
              editForm.controls['newEmail'].errors?.server !== null &&
              editForm.controls['newEmail'].errors?.server !== undefined &&
              (editForm.controls['newEmail'].touched || ngForm.submitted)
            "
          >
            {{
              getValidationMessage(editForm.controls['newEmail'].errors?.server)
                | translate
            }}
          </mat-error>
        </div>

        <div class="form-group">
          <label>{{ 'label.EnterCurrentPassword' | translate }}</label>

          <hrra-password-input
              formControlName="password"
              [withPlaceholder]="false"
              autocomplete="off"
            >
          </hrra-password-input>
          <mat-error
            *ngIf="isCurrentPasswordIncorrect$ | async"
            class="validation-message"
            >{{
              'message.CurrentPasswordYouEnteredIsIncorrect' | translate
            }}</mat-error
          >

          <mat-error
            *ngIf="editForm.get('password')?.errors?.['required'] && (editForm.controls['password'].touched || ngForm.submitted)"
            class="validation-message"
            >{{ 'message.MandatoryField' | translate }}</mat-error
          >
        </div>

        <div class="buttons">
          <button (click)="onSave()" class="buttons__save">
            {{ 'label.StartEditing' | translate }}
          </button>
          <app-button
            (click)="onCancel()"
            [text]="'label.Cancel' | translate"
            [type]="buttonType.uncoloured"
            [typeAttribute]="buttonAttributeType.button"
            class="buttons__cancel"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
